import { MdArtTrack } from "react-icons/md";
import { formatThisAndThatList } from "../../common/shared";
import { defineType } from "sanity";
import { isPresent } from "../../utils/checks";
import {
  MultilingualArrayStringValue,
  multilingualStringPreview
} from "../base/multilingualArrayString";

const serviceTitles = (services: { title: MultilingualArrayStringValue }[]) => {
  const titles = (services || [])
    .map((x) => x.title && multilingualStringPreview(x.title))
    .filter(isPresent);

  return titles.length ? formatThisAndThatList(titles) : undefined;
};

export default defineType({
  title: "Service Rows",
  name: "serviceRows",
  type: "object",
  icon: MdArtTrack,
  fields: [
    {
      name: "sectionLayoutConfig",
      type: "sectionLayoutConfig",
      title: "Section Layout",
      options: {
        collapsed: true,
        collapsable: true
      }
    },
    {
      name: "heading",
      title: "Section Heading",
      type: "sectionTitle",
      options: {
        collapsable: true
      }
    },
    {
      name: "anchor",
      title: "Anchor",
      type: "string",
      validation: (Rule) => Rule.regex(/[a-z-]+/)
    },
    {
      name: "services",
      title: "Services",
      type: "array",
      of: [{ type: "serviceRow" }]
    }
  ],
  preview: {
    select: {
      title: "heading.title",
      services: "services"
    },
    prepare(selection) {
      const { title, services } = selection;
      return {
        title:
          multilingualStringPreview(title) ||
          serviceTitles(services) ||
          "(Service Rows)",
        subtitle: `Services: ${services.length}`
      };
    }
  }
});
